module.exports = "/_next/static/images/71006c5fa45509146c2ad117632ecc4f-pay-yourself-lg@2x.jpg.webp";